var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vehicle-map-info-card"},_vm._l((_vm.rows),function(row){return _c('div',{key:row.key,staticClass:"vehicle-map-info-card__row"},[_c('span',{staticClass:"vehicle-map-info-card__label"},[_vm._v(_vm._s(row.label))]),_c('span',{staticClass:"vehicle-map-info-card__value"},[_vm._v(_vm._s(row.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }